export default __webpack_public_path__ + "static/media/BackgroundArc.e29c4514.png";